/**
 * Hàm replace string chứa các ký tự &<>"'`= thành kí tự html
 * Support cho phần cộng chuỗi
 * Hàm replaceEscapeHtml() khác với hàm `replaceQuoteCharacter() do replaceQuoteCharacter() chỉ replace 2 kí tự là "' nên ko merge thành 1 được
 * @param str String
 * @returns new string before replace
 */
export default (str: string): string => {
  if (!str) {
    return str;
  }
  const entityMap: any = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;',
  };
  const reg = new RegExp(/[&<>"'`=\\/]/g);
  return str.replace(reg, function fromEntityMap(s: string) {
    return entityMap[s];
  });
};
